import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'

import { RelatedList, RelatedListItem, RelatedSettings } from 'components/RelatedSettings'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { ROUTES } from 'routes'

import type { WorkspaceDefaults } from '../useGetWorkspaceDefaults'

export const EmployeeSettingsWorkspaceDefaults = ({
  workspaceDefaults,
}: {
  workspaceDefaults: WorkspaceDefaults
}): React.JSX.Element => {
  const { t: tc } = useTranslation('common')
  const { t } = useTranslation('features/domain', {
    keyPrefix: 'form.richPlacements.kWords.workspaceDefaults',
  })
  const { workspaceId } = useWorkspaceParam()

  const { kwordsSiteId } = workspaceDefaults

  return (
    <RelatedSettings title={t('title')}>
      <RelatedList>
        <RelatedListItem
          content={t('kwordsSiteId')}
          url={generatePath(ROUTES.GLOBAL_SETUP.DEFAULTS.ROOT, {
            section: 'k-words',
            tab: 'rich-placements',
            workspaceId,
          })}
          value={kwordsSiteId ?? tc('definedState.false')}
        />
      </RelatedList>
    </RelatedSettings>
  )
}
